import { render, staticRenderFns } from "./work-item-log.vue?vue&type=template&id=5d5c1b01&scoped=true"
import script from "./work-item-log.js?vue&type=script&lang=js&external"
export * from "./work-item-log.js?vue&type=script&lang=js&external"
import style0 from "./work-item-log.vue?vue&type=style&index=0&id=5d5c1b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c1b01",
  null
  
)

export default component.exports